import { Box } from '@mui/material';

const MedicationAppearanceIcon = ({ Icon, size = 24, color = 'primary.main' }) => {
    return (
        <Box
            component={Icon}
            sx={{
                width: size,
                height: size,
                color
            }}
        />
    );
};

export default MedicationAppearanceIcon;
